import { Text } from '@croquiscom-pvt/zds';
import styled from '@emotion/styled';

import { NotifyItem } from '../../types/benefit';

export const NotifySubItem = (subItem: NotifyItem) => {
  return (
    <Container key={subItem.content}>
      <Text variant='Body_13_Regular' color='stateNegativePrimary'>
        {subItem.content}
      </Text>
    </Container>
  );
};

const Container = styled.div`
  padding: 4px 0 4px 24px;
`;
